module.exports = function(app) {
	app.filter('ssnMask', function() {
		return function(ssn) {

			return (ssn instanceof String || typeof ssn === 'string') && ssn.length === 9
				? '<span>&lowast;&lowast;&lowast;&lowast;&lowast;' + ssn.slice(-4) + '</span>'
				: ssn || '';
		};
	});

	app.directive('eprSsnToggle', [function() {
		return {
			restrict: 'A',
			replace: false,
			template: require('directives/common/eprSsnToggle.html'),

			scope: {
				ssn: '=?eprSsnToggle'
			},

			controller: ['$element', '$scope', '$window', function($element, $scope, $window) {

				$scope.toggleSSN = function(isExposed) {
					$scope.isExposed = !isExposed;
				};

				var $button = $element.find('button');

				angular.element($window).click(function(event) {
					var $target = $(event.target);

					if ( !($target.closest($button).length) ) {
						$scope.$apply(function() { $scope.toggleSSN(true); });
					}
				});
			}]
		};
	}]);
};
